import styled from 'styled-components'

import { Box, Text } from '@redriverpress/system'

const Hr = styled.hr`
  border: 0;
  background: ${({ theme }) => theme.colors.gray200};
  height: 2px;
  flex-grow: 1;
`

export default function Divider(props) {
  return (
    <Box display='flex' alignItems='center' {...props}>
      <Hr />
      <Text fontWeight={600} fontSize={2} px={2}>
        or
      </Text>
      <Hr />
    </Box>
  )
}
